import { render, staticRenderFns } from "./OrderAnalyticsData.vue?vue&type=template&id=6a0fc89e"
import script from "./OrderAnalyticsData.vue?vue&type=script&lang=js"
export * from "./OrderAnalyticsData.vue?vue&type=script&lang=js"
import style0 from "./OrderAnalyticsData.vue?vue&type=style&index=0&id=6a0fc89e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports